<template>
  <v-main color="secondary">Dashboard</v-main>
</template>

<script>
export default {
  data: () => ({}),
  components: {},
  methods: {}
};
</script>

<style lang="scss"></style>
